import { Storage } from "../memento/storage";

const X_USER_ID = 'X-User-Id';
const X_ACCESS_TOKEN = 'X-Access-Token';

export class ACL {

  static getCurrentAuthorizedPath() {

    const userId = Storage.getItem('userId');
    const accessToken = Storage.getItem('accessToken');
    console.log(Storage.getItem('X_origin'))


    return new Promise((resolve, reject) => {

      if (userId && userId !== 'undefined' && accessToken && accessToken !== 'undefined') {

        fetch(`/api/v1/users/${userId}`, {
          method: 'GET',
          headers: {
            'Accept': '*/*',
            'X-Access-Token': accessToken,
            'X-Lang-Code': 'ES',
            'Content-Type': 'application/json'
          },
          cors: 'no-cors',
          cache: 'no-cache'
        })
          .then(response => {

            if (response.status >= 400) {
              Storage.clear();

              return reject();
            } else {
              return resolve(
                `${__WEB_APP_HOST__}?
                accessToken=${encodeURIComponent(accessToken)}&
                userId=${encodeURIComponent(userId)}`
              );
            }
          })
          .catch(() => {

            Storage.clear();

            return reject();
          });
      } else {
        return reject();
      }
    });
  }

  static getAuthorizedPath(response) {

    const userId = response.headers.get(X_USER_ID);
    const accessToken = response.headers.get(X_ACCESS_TOKEN);

    return `${__WEB_APP_HOST__}?accessToken=${encodeURIComponent(accessToken)}&userId=${encodeURIComponent(userId)}`;
  }
}
